import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>Job Listing</h1><span></span></div></div></div></div></div>", 1)
const _hoisted_2 = {
  class: "job-listing-area pt-120 mb-120",
  id: "scrollTarget"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row g-lg-4 gy-5" }
const _hoisted_5 = { class: "col-lg-4 order-lg-1 order-2" }
const _hoisted_6 = { class: "job-sidebar" }
const _hoisted_7 = { class: "job-widget style-1 mb-20" }
const _hoisted_8 = { class: "check-box-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "job-widget-title" }, "Job Category", -1)
const _hoisted_10 = { class: "checkbox-container" }
const _hoisted_11 = { class: "containerss" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "qty" }
const _hoisted_16 = { class: "job-widget mb-20" }
const _hoisted_17 = { class: "check-box-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", { class: "job-widget-title" }, "Type of Employments", -1)
const _hoisted_19 = { class: "checkbox-container" }
const _hoisted_20 = { class: "containerss" }
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "qty" }
const _hoisted_25 = { class: "job-widget mb-20" }
const _hoisted_26 = { class: "check-box-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "job-widget-title" }, "Date of Post", -1)
const _hoisted_28 = { class: "salary-container" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "content" }
const _hoisted_31 = { class: "text" }
const _hoisted_32 = { class: "qty" }
const _hoisted_33 = { class: "job-widget mb-20" }
const _hoisted_34 = { class: "check-box-item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h5", { class: "job-widget-title mb-15" }, "Salary Range", -1)
const _hoisted_36 = { class: "salary-container" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "content" }
const _hoisted_39 = { class: "text" }
const _hoisted_40 = { class: "qty" }
const _hoisted_41 = { class: "col-lg-8 order-lg-2 order-1" }
const _hoisted_42 = { class: "job-listing-wrrap" }
const _hoisted_43 = { class: "row g-4 mb-25" }
const _hoisted_44 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_45 = { class: "show-item" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "job-listing-card" }
const _hoisted_49 = { class: "job-top" }
const _hoisted_50 = { class: "job-list-content" }
const _hoisted_51 = {
  class: "company-area",
  style: {"min-width":"fit-content"}
}
const _hoisted_52 = { class: "logo" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "company-details" }
const _hoisted_55 = { class: "name-location" }
const _hoisted_56 = { class: "job-discription" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Application Close:", -1)
const _hoisted_59 = { style: {"line-height":"1.5rem"} }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Summary: ", -1)
const _hoisted_61 = { class: "job-type-apply" }
const _hoisted_62 = { class: "job-type" }
const _hoisted_63 = { class: "light-green" }
const _hoisted_64 = {
  key: 0,
  class: "apply-btn"
}
const _hoisted_65 = { class: "col-lg-12 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trending_jobs_categories, (category) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: category.id
                        }, [
                          _createElementVNode("label", _hoisted_11, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: category.id,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jobCategoryFilter) = $event)),
                              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterJobs && _ctx.filterJobs(...args)))
                            }, null, 40, _hoisted_12), [
                              [_vModelCheckbox, _ctx.jobCategoryFilter]
                            ]),
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(category.name), 1),
                            _createElementVNode("span", _hoisted_15, "(" + _toDisplayString(category.cat_counts) + ")", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobTypeFilters, (jobType) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: jobType.id
                        }, [
                          _createElementVNode("label", _hoisted_20, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: jobType.id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.JobTypeFilter) = $event)),
                              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterJobs && _ctx.filterJobs(...args)))
                            }, null, 40, _hoisted_21), [
                              [_vModelCheckbox, _ctx.JobTypeFilter]
                            ]),
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(jobType.name), 1),
                            _createElementVNode("span", _hoisted_24, "(" + _toDisplayString(jobType.counts) + ")", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPostedFilters, (jobPosted) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: jobPosted.id
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "showInputBox",
                            value: jobPosted.id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.JobPostedOnFilter) = $event)),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.filterJobs && _ctx.filterJobs(...args)))
                          }, null, 40, _hoisted_29), [
                            [_vModelRadio, _ctx.JobPostedOnFilter]
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(jobPosted.name), 1),
                            _createElementVNode("span", _hoisted_32, "(" + _toDisplayString(jobPosted.counts) + ")", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salaryRangeFilters, (SalaryRange) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: SalaryRange.id
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: "showInputBox",
                            value: SalaryRange.id,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.SalaryRangeFilter) = $event)),
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.filterJobs && _ctx.filterJobs(...args)))
                          }, null, 40, _hoisted_37), [
                            [_vModelRadio, _ctx.SalaryRangeFilter]
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("span", _hoisted_39, _toDisplayString(SalaryRange.name), 1),
                            _createElementVNode("span", _hoisted_40, "(" + _toDisplayString(SalaryRange.counts) + ")", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("p", _hoisted_45, "Showing results 10 in " + _toDisplayString(_ctx.totalPages) + " jobs list", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createVNode(_component_ProgressSpinner)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.jobs, (job) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: job.id,
                        class: "col-lg-12 mb-30"
                      }, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("img", {
                                    src: (job.company_logo) ? job.company_logo : '/assets/images/work-pages-logo.png',
                                    alt: ""
                                  }, null, 8, _hoisted_53)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("h5", null, [
                                      _createVNode(_component_router_link, {
                                        to: _ctx.getJobDetail(job.job_key, job.job_slug)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.job_title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createVNode(_component_router_link, {
                                        to: '/company-details?company_id=' + job.company_id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.company), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("ul", null, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("p", null, [
                                      _hoisted_57,
                                      _createTextVNode(" " + _toDisplayString(job.salary_range), 1)
                                    ])
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("p", null, [
                                      _hoisted_58,
                                      _createTextVNode(_toDisplayString(job.expiration), 1)
                                    ])
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("p", _hoisted_59, [
                                      _hoisted_60,
                                      _createTextVNode(_toDisplayString(job.job_description.slice(0, 30)), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("span", _hoisted_63, _toDisplayString(job.working_mode) + " " + _toDisplayString(job.expiration), 1)
                            ]),
                            (!_ctx.isJobExpired(job.expiration))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  (_ctx.loggedIn)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "primry-btn-2 y-btn lg-btn",
                                        to: _ctx.getJobDetail(job.job_key, job.job_slug, 'apply')
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Apply Now")
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        to: { name: 'login' },
                                        class: "primry-btn-2 y-btn lg-btn"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Login to apply")
                                        ]),
                                        _: 1
                                      }))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128)),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_Paginator, {
                    first: _ctx.currentPage,
                    "onUpdate:first": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentPage) = $event)),
                    rows: _ctx.rowsPerPage,
                    totalRecords: _ctx.totalPages,
                    onPage: _ctx.handlePageChange
                  }, null, 8, ["first", "rows", "totalRecords", "onPage"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}